"use strict";
module.exports = {
    entityModel: 'supplierCustomerInOmsService',
    events: {
        SUPPLIER_CUSTOMER_IN_OMS_SERVICE_CREATED: 'SUPPLIER_CUSTOMER_IN_OMS_SERVICE_CREATED',
        SUPPLIER_CUSTOMER_IN_OMS_SERVICE_UPDATED: 'SUPPLIER_CUSTOMER_IN_OMS_SERVICE_UPDATED',
    },
    actions: {
        get: 'v1.supplierCustomerInOmsService.get',
        list: 'v1.supplierCustomerInOmsService.list',
        upsert: 'v1.supplierCustomerInOmsService.upsert',
        upsertWhenEmpty: 'v1.supplierCustomerInOmsService.upsertWhenEmpty',
        updateWhenEmpty: 'v1.supplierCustomerInOmsService.updateWhenEmpty',
        update: 'v1.supplierCustomerInOmsService.update',
    },
    customerTypes: {
        horeca: 'horeca',
        dvh: 'dvh',
        wholesale: 'wholesale',
        office: 'office',
        systembolaget: 'systembolaget',
        supplier: 'supplier',
        export: 'export',
        other: 'other',
    },
    deliveryCountries: {
        SE: 'SE',
        FI: 'FI',
        NO: 'NO',
        DK: 'DK',
        IS: 'IS',
    },
    invoiceCountries: {
        SE: 'SE',
        FI: 'FI',
        NO: 'NO',
        DK: 'DK',
        IS: 'IS',
    },
    termsOfPayments: {
        0: '0',
        10: '10',
        15: '15',
        20: '20',
        30: '30',
        35: '35',
        60: '60',
        70: '70',
        A: 'A',
        K: 'K',
        PF: 'PF',
    },
};
